/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online cron expression explainer. Paste a 5-field crontab schedule to get a clear plain-English description and a field-by-field breakdown. Works in your browser.`)
};

const es_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador gratuito de expresiones cron en línea. Pega un horario de crontab de 5 campos para obtener una descripción clara en lenguaje plano y un desglose campo por campo. Funciona en tu navegador.`)
};

const de_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Cron-Ausdruck-Erklärer. Fügen Sie einen fünfteiligen Crontab-Zeitplan ein und erhalten Sie eine klare, leicht verständliche Beschreibung sowie eine Aufschlüsselung Feld für Feld. Funktioniert direkt in Ihrem Browser.`)
};

const nl_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online cron-expressie verklaarder. Plak een 5-veld crontab-schema om een duidelijke Nederlands beschrijving en een afbraak per veld te krijgen. Werkt in uw browser.`)
};

const fr_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expliciteur gratuit d'expressions cron en ligne. Collez un horaire crontab à 5 champs pour obtenir une description claire en langage courant et une décomposition champ par champ. Fonctionne dans votre navigateur.`)
};

const it_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiegatore gratuito online di espressioni cron. Incolla una pianificazione crontab a 5 campi per ottenere una descrizione chiara in italiano semplice e una suddivisione campo per campo. Funziona nel tuo browser.`)
};

const pt_br2_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador gratuito de expressões cron online. Cole um cronograma crontab de 5 campos para obter uma descrição clara em linguagem simples e um detalhamento campo a campo. Funciona no seu navegador.`)
};

const pt_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador gratuito de expressões cron em linha. Cole um agendamento crontab de 5 campos para obter uma descrição clara em português claro e uma decomposição campo a campo. Funciona no seu navegador.`)
};

const ja_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインcron式エクスプレーナー。5フィールドのcrontabスケジュールをペーストして、わかりやすい説明とフィールド単位の分解を取得します。ブラウザで動作します。`)
};

const zh_cr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 Cron 表达式解释器。粘贴一个五字段的 crontab 计划，即可获得清晰易懂的说明和逐字段解析。可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_meta_description", locale)
	if (locale === "en") return en_cr_meta_description(inputs)
	if (locale === "es") return es_cr_meta_description(inputs)
	if (locale === "de") return de_cr_meta_description(inputs)
	if (locale === "nl") return nl_cr_meta_description(inputs)
	if (locale === "fr") return fr_cr_meta_description(inputs)
	if (locale === "it") return it_cr_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_cr_meta_description(inputs)
	if (locale === "pt") return pt_cr_meta_description(inputs)
	if (locale === "ja") return ja_cr_meta_description(inputs)
	return zh_cr_meta_description(inputs)
};